import script from "./chart3.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart3.vue?vue&type=script&lang=ts&setup=true"

import "./chart3.vue?vue&type=style&index=0&id=5db4d996&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db4d996"]])

export default __exports__